(function () {
  'use strict';

  var API_PATH = '/apps/editor/api/withdrawal';

  // -- Translations --
  var T = {
    sv: {
      orderLabel: 'Ordernummer',
      emailLabel: 'E-postadress',
      lookupBtn: 'Sök order',
      backBtn: 'Tillbaka',
      confirmBtn: 'Bekräfta retur',
      cancelBtn: 'Avbeställ order',
      cancelDescription: 'Denna order har inte skickats ännu och kan avbeställas. Du får full återbetalning.',
      selectAll: 'Välj alla',
      badgeEligible: 'Returnerbar',
      badgePersonalized: 'Personlig produkt',
      badgeFreeItem: 'Gratisartikel',
      badgeWithdrawn: 'Redan ångrad',
      badgeExpired: 'Ångerfristen har passerat',
      noEligibleMsg: 'Det finns inga artiklar i denna order som kan ångras.',
      errorNotFound: 'Ordern hittades inte. Kontrollera ordernummer och/eller e-postadress.',
      errorCancelled: 'Denna order har redan avbeställts.',
      errorNoEligible: 'Det finns inga artiklar som kan ångras i denna order.',
      errorNoneSelected: 'Välj minst en artikel att ångra.',
      errorGeneric: 'Något gick fel. Försök igen.',
      qty: 'st',
    },
    no: {
      orderLabel: 'Ordrenummer',
      emailLabel: 'E-postadresse',
      lookupBtn: 'Søk ordre',
      backBtn: 'Tilbake',
      confirmBtn: 'Bekreft retur',
      cancelBtn: 'Avbestill ordre',
      cancelDescription: 'Denne ordren er ikke sendt ennå og kan avbestilles. Du får full refusjon.',
      selectAll: 'Velg alle',
      badgeEligible: 'Returnerbar',
      badgePersonalized: 'Personlig produkt',
      badgeFreeItem: 'Gratisartikkel',
      badgeWithdrawn: 'Allerede angret',
      badgeExpired: 'Angrefristen har utløpt',
      noEligibleMsg: 'Det er ingen artikler i denne ordren som kan angres.',
      errorNotFound: 'Ordren ble ikke funnet. Sjekk ordrenummer og/eller e-postadresse.',
      errorCancelled: 'Denne ordren er allerede avbestilt.',
      errorNoEligible: 'Det er ingen artikler som kan angres i denne ordren.',
      errorNoneSelected: 'Velg minst én artikkel å angre.',
      errorGeneric: 'Noe gikk galt. Prøv igjen.',
      qty: 'stk',
    },
    de: {
      orderLabel: 'Bestellnummer',
      emailLabel: 'E-Mail-Adresse',
      lookupBtn: 'Bestellung suchen',
      backBtn: 'Zurück',
      confirmBtn: 'Rückgabe bestätigen',
      cancelBtn: 'Bestellung stornieren',
      cancelDescription: 'Diese Bestellung wurde noch nicht versandt und kann storniert werden. Sie erhalten eine vollständige Rückerstattung.',
      selectAll: 'Alle auswählen',
      badgeEligible: 'Retournierbar',
      badgePersonalized: 'Personalisiertes Produkt',
      badgeFreeItem: 'Gratisartikel',
      badgeWithdrawn: 'Bereits widerrufen',
      badgeExpired: 'Widerrufsfrist abgelaufen',
      noEligibleMsg: 'Es gibt keine Artikel in dieser Bestellung, die widerrufen werden können.',
      errorNotFound: 'Bestellung nicht gefunden. Bitte überprüfen Sie Bestellnummer und/oder E-Mail-Adresse.',
      errorCancelled: 'Diese Bestellung wurde bereits storniert.',
      errorNoEligible: 'Es gibt keine Artikel in dieser Bestellung, die widerrufen werden können.',
      errorNoneSelected: 'Bitte wählen Sie mindestens einen Artikel zum Widerrufen aus.',
      errorGeneric: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
      qty: 'Stk',
    },
    en: {
      orderLabel: 'Order number',
      emailLabel: 'Email address',
      lookupBtn: 'Look up order',
      backBtn: 'Back',
      confirmBtn: 'Confirm Return',
      cancelBtn: 'Cancel order',
      cancelDescription: 'This order has not been shipped yet and can be cancelled. You will receive a full refund.',
      selectAll: 'Select all',
      badgeEligible: 'Returnable',
      badgePersonalized: 'Personalized product',
      badgeFreeItem: 'Free item',
      badgeWithdrawn: 'Already withdrawn',
      badgeExpired: 'Withdrawal period expired',
      noEligibleMsg: 'There are no items in this order that can be withdrawn.',
      errorNotFound: 'Order not found. Please check your order number and/or email address.',
      errorCancelled: 'This order has already been cancelled.',
      errorNoEligible: 'There are no items eligible for withdrawal in this order.',
      errorNoneSelected: 'Please select at least one item to withdraw.',
      errorGeneric: 'Something went wrong. Please try again.',
      qty: 'qty',
    },
  };

  // -- State --
  var state = {
    locale: 'en',
    orderName: '',
    email: '',
    type: '',
    items: [],
  };

  // -- Helpers --

  function t(key) {
    var strings = T[state.locale] || T.en;
    return strings[key] || T.en[key] || key;
  }

  function detectLocale() {
    var lang = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en';
    lang = lang.toLowerCase().split('-')[0];
    if (T[lang]) return lang;
    return 'en';
  }

  function $(selector) {
    return document.querySelector(selector);
  }

  function $$(selector) {
    return document.querySelectorAll(selector);
  }

  function showStep(num) {
    $$('.pa-wd-step').forEach(function (el) {
      var step = parseInt(el.getAttribute('data-step'), 10);
      if (step === num) {
        el.hidden = false;
        el.classList.add('pa-wd-step--active');
      } else {
        el.hidden = true;
        el.classList.remove('pa-wd-step--active');
      }
    });
  }

  function showError(id, msg) {
    var el = document.getElementById(id);
    if (el) {
      el.textContent = msg;
      el.hidden = false;
    }
  }

  function hideError(id) {
    var el = document.getElementById(id);
    if (el) el.hidden = true;
  }

  function setLoading(btn, loading) {
    if (loading) {
      btn.disabled = true;
      btn.classList.add('pa-wd-btn--loading');
    } else {
      btn.disabled = false;
      btn.classList.remove('pa-wd-btn--loading');
    }
  }

  function apiCall(data) {
    return fetch(API_PATH, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).then(function (res) {
      return res.json().then(function (body) {
        return { ok: res.ok, status: res.status, body: body };
      });
    });
  }

  function formatPrice(price) {
    try {
      return new Intl.NumberFormat(state.locale, {
        style: 'currency',
        currency: price.currencyCode,
      }).format(parseFloat(price.amount));
    } catch (e) {
      return price.amount + ' ' + price.currencyCode;
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  // -- Rendering --

  function populateI18n() {
    $$('[data-i18n]').forEach(function (el) {
      var key = el.getAttribute('data-i18n');
      el.textContent = t(key);
    });
    var orderInput = $('#pa-wd-order');
    var emailInput = $('#pa-wd-email');
    if (orderInput) orderInput.placeholder = '1234';
    if (emailInput) emailInput.placeholder = 'name@example.com';
  }

  function updateConfirmButton() {
    var checked = document.querySelectorAll('.pa-wd-item__checkbox:checked');
    var confirmBtn = $('#pa-wd-confirm-btn');
    if (confirmBtn) confirmBtn.disabled = checked.length === 0;
  }

  function renderItems(items) {
    var container = $('#pa-wd-items');
    container.innerHTML = '';

    var hasEligible = items.some(function (i) { return i.eligible; });

    // Select all toggle (only if there are multiple eligible items)
    var eligibleCount = items.filter(function (i) { return i.eligible; }).length;
    if (eligibleCount > 1) {
      var selectAll = document.createElement('label');
      selectAll.className = 'pa-wd-select-all';
      selectAll.innerHTML =
        '<input type="checkbox" id="pa-wd-select-all" checked />' +
        '<span>' + t('selectAll') + '</span>';
      container.appendChild(selectAll);

      selectAll.querySelector('input').addEventListener('change', function () {
        var checkboxes = document.querySelectorAll('.pa-wd-item__checkbox');
        var isChecked = this.checked;
        checkboxes.forEach(function (cb) { cb.checked = isChecked; });
        updateConfirmButton();
      });
    }

    items.forEach(function (item, index) {
      var div = document.createElement('div');
      div.className = 'pa-wd-item' + (item.eligible ? '' : ' pa-wd-item--ineligible');

      var checkboxHtml = '';
      if (item.eligible) {
        checkboxHtml = '<input type="checkbox" class="pa-wd-item__checkbox" data-index="' + index + '" checked />';
      }

      var imgHtml;
      if (item.imageUrl) {
        imgHtml = '<img class="pa-wd-item__image" src="' + item.imageUrl + '&width=120" alt="" loading="lazy" />';
      } else {
        imgHtml = '<div class="pa-wd-item__image--placeholder">&#9634;</div>';
      }

      var badgeClass, badgeText;
      if (item.eligible) {
        badgeClass = 'pa-wd-item__badge--eligible';
        badgeText = t('badgeEligible');
      } else if (item.reason === 'personalized') {
        badgeClass = 'pa-wd-item__badge--personalized';
        badgeText = t('badgePersonalized');
      } else if (item.reason === 'free_item') {
        badgeClass = 'pa-wd-item__badge--personalized';
        badgeText = t('badgeFreeItem');
      } else if (item.reason === 'withdrawal_period_expired') {
        badgeClass = 'pa-wd-item__badge--withdrawn';
        badgeText = t('badgeExpired');
      } else {
        badgeClass = 'pa-wd-item__badge--withdrawn';
        badgeText = t('badgeWithdrawn');
      }

      div.innerHTML =
        checkboxHtml +
        imgHtml +
        '<div class="pa-wd-item__info">' +
          '<p class="pa-wd-item__title">' + escapeHtml(item.title) + '</p>' +
          '<span class="pa-wd-item__meta">' + item.quantity + ' ' + t('qty') + ' &middot; ' + formatPrice(item.price) + '</span>' +
        '</div>' +
        '<span class="pa-wd-item__badge ' + badgeClass + '">' + badgeText + '</span>';

      container.appendChild(div);
    });

    // Listen for checkbox changes to update confirm button and select-all state
    container.addEventListener('change', function (e) {
      if (e.target.classList.contains('pa-wd-item__checkbox')) {
        updateConfirmButton();
        // Sync select-all checkbox
        var selectAllCb = $('#pa-wd-select-all');
        if (selectAllCb) {
          var all = document.querySelectorAll('.pa-wd-item__checkbox');
          var allChecked = Array.prototype.every.call(all, function (cb) { return cb.checked; });
          selectAllCb.checked = allChecked;
        }
      }
    });
  }

  function renderCancelItems(items) {
    var container = $('#pa-wd-items');
    container.innerHTML = '';

    items.forEach(function (item) {
      var div = document.createElement('div');
      div.className = 'pa-wd-item';

      var imgHtml;
      if (item.imageUrl) {
        imgHtml = '<img class="pa-wd-item__image" src="' + item.imageUrl + '&width=120" alt="" loading="lazy" />';
      } else {
        imgHtml = '<div class="pa-wd-item__image--placeholder">&#9634;</div>';
      }

      div.innerHTML =
        imgHtml +
        '<div class="pa-wd-item__info">' +
          '<p class="pa-wd-item__title">' + escapeHtml(item.title) + '</p>' +
          '<span class="pa-wd-item__meta">' + item.quantity + ' ' + t('qty') + ' &middot; ' + formatPrice(item.price) + '</span>' +
        '</div>';

      container.appendChild(div);
    });
  }

  // -- Error mapping from API responses --

  function lookupErrorMessage(body) {
    if (body.error === 'Order already cancelled') return t('errorCancelled');
    return t('errorNotFound');
  }

  // -- Event handlers --

  function onLookup(e) {
    e.preventDefault();
    hideError('pa-wd-lookup-error');

    var orderInput = $('#pa-wd-order');
    var emailInput = $('#pa-wd-email');
    var btn = e.target.querySelector('button[type="submit"]');

    state.orderName = orderInput.value.trim();
    state.email = emailInput.value.trim();

    setLoading(btn, true);

    apiCall({
      action: 'lookup',
      orderName: state.orderName,
      email: state.email,
    }).then(function (res) {
      setLoading(btn, false);

      if (!res.ok) {
        showError('pa-wd-lookup-error', lookupErrorMessage(res.body));
        return;
      }

      state.type = res.body.type;

      // Unfulfilled order → show cancel confirmation with item list
      if (state.type === 'cancel') {
        var cancelDesc = $('#pa-wd-cancel-description');
        var cancelForm = $('#pa-wd-cancel-form');
        var confirmForm = $('#pa-wd-confirm-form');
        var itemsContainer = $('#pa-wd-items');
        var noEligibleMsg = $('#pa-wd-no-eligible');

        if (cancelDesc) cancelDesc.hidden = false;
        if (cancelForm) cancelForm.hidden = false;
        if (confirmForm) confirmForm.hidden = true;
        if (noEligibleMsg) noEligibleMsg.hidden = true;

        renderCancelItems(res.body.items || []);

        showStep(2);
        return;
      }

      // Fulfilled order → show item selection for withdrawal
      state.items = res.body.items || [];

      var cancelDesc = $('#pa-wd-cancel-description');
      var cancelForm = $('#pa-wd-cancel-form');
      if (cancelDesc) cancelDesc.hidden = true;
      if (cancelForm) cancelForm.hidden = true;

      renderItems(state.items);

      var hasEligible = state.items.some(function (i) { return i.eligible; });
      var confirmForm = $('#pa-wd-confirm-form');
      var noEligibleMsg = $('#pa-wd-no-eligible');

      if (hasEligible) {
        confirmForm.hidden = false;
        noEligibleMsg.hidden = true;
      } else {
        confirmForm.hidden = true;
        noEligibleMsg.hidden = false;
      }

      showStep(2);
    }).catch(function () {
      setLoading(btn, false);
      showError('pa-wd-lookup-error', t('errorGeneric'));
    });
  }

  function onConfirm(e) {
    e.preventDefault();
    hideError('pa-wd-confirm-error');

    var selectedIds = [];
    document.querySelectorAll('.pa-wd-item__checkbox:checked').forEach(function (cb) {
      var index = parseInt(cb.getAttribute('data-index'), 10);
      selectedIds.push(state.items[index].fulfillmentLineItemId);
    });

    if (selectedIds.length === 0) {
      showError('pa-wd-confirm-error', t('errorNoneSelected'));
      return;
    }

    var btn = $('#pa-wd-confirm-btn');
    setLoading(btn, true);

    apiCall({
      action: 'confirm',
      orderName: state.orderName,
      email: state.email,
      fulfillmentLineItemIds: selectedIds,
    }).then(function (res) {
      setLoading(btn, false);

      if (!res.ok) {
        showError('pa-wd-confirm-error', res.body.error || t('errorGeneric'));
        return;
      }

      showStep(3);
    }).catch(function () {
      setLoading(btn, false);
      showError('pa-wd-confirm-error', t('errorGeneric'));
    });
  }

  function onCancel(e) {
    e.preventDefault();
    hideError('pa-wd-cancel-error');

    var btn = $('#pa-wd-cancel-btn');
    setLoading(btn, true);

    apiCall({
      action: 'cancel',
      orderName: state.orderName,
      email: state.email,
    }).then(function (res) {
      setLoading(btn, false);

      if (!res.ok) {
        showError('pa-wd-cancel-error', res.body.error || t('errorGeneric'));
        return;
      }

      showStep(3);
    }).catch(function () {
      setLoading(btn, false);
      showError('pa-wd-cancel-error', t('errorGeneric'));
    });
  }

  function onBack() {
    hideError('pa-wd-confirm-error');
    hideError('pa-wd-cancel-error');
    showStep(1);
  }

  // -- Init --

  function init() {
    state.locale = detectLocale();
    populateI18n();

    var lookupForm = $('#pa-wd-lookup-form');
    var confirmForm = $('#pa-wd-confirm-form');
    var cancelForm = $('#pa-wd-cancel-form');
    var backBtn = $('#pa-wd-back-btn');

    if (lookupForm) lookupForm.addEventListener('submit', onLookup);
    if (confirmForm) confirmForm.addEventListener('submit', onConfirm);
    if (cancelForm) cancelForm.addEventListener('submit', onCancel);
    if (backBtn) backBtn.addEventListener('click', onBack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
